import React from "react";

import type { T_PortfolioHomeDirection } from "./types";
import "./portfolio-home.css";

export type T_PortfolioSummaryHeaderProps = {
  dayPercentChange: number;
  direction: T_PortfolioHomeDirection;
  marketOneLiner: string | null;
};

export function PortfolioSummaryHeader({
  dayPercentChange,
  direction,
  marketOneLiner,
}: T_PortfolioSummaryHeaderProps) {
  const isDown = direction === "down";
  const percentLabel = `${isDown ? "-" : "+"}${Math.abs(dayPercentChange).toFixed(2)}%`;

  return (
    <header className="portfolio-summary-header">
      <p className="portfolio-summary-header__line">
        Your portfolio is {isDown ? "down" : "up"}{" "}
        <span
          className={
            isDown
              ? "portfolio-summary-header__percent portfolio-summary-header__percent--down"
              : "portfolio-summary-header__percent portfolio-summary-header__percent--up"
          }
        >
          {percentLabel}
        </span>{" "}
        today.
      </p>
      {marketOneLiner ? (
        <p className="portfolio-summary-header__line">{marketOneLiner}</p>
      ) : null}
    </header>
  );
}
